import { useQuery } from "@tanstack/react-query";

import { fetchDataGet } from "@/core/api/api-methods";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { walletEndpoints } from "@/features/wallet/api/endpoints";
import type { WalletDto } from "@/features/wallet/api/dto";

/** Détail d'un portefeuille (`GET /Wallets/{id}`). */
export const useWallet = (walletId: string, enabled = true) =>
  useQuery({
    queryKey: QUERY_KEYS.WALLET_DETAIL(walletId),
    queryFn: () =>
      fetchDataGet<WalletDto>({ url: walletEndpoints.wallets.detail(walletId) }),
    retry: (failureCount, error) =>
      !/401/.test(error?.message ?? "") && failureCount < 1,
    enabled: enabled && Boolean(walletId),
  });
